module.exports = __webpack_public_path__ + "static/img/qmwallet1_quit_confirm.2d25312a.png";